<template>
  <native-app-webview :auto-set-is-loaded="false">
    <div class="px-4">
      <EODReports :display-site-selector="false" :site-id="siteId" @mount="setBasecampIsLoaded" />
    </div>
  </native-app-webview>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import { setBasecampIsLoaded } from "@/utils/native-app-webview";
const route = useRoute();
const siteId = route.query.siteId as string | undefined;
</script>
